import { GuideStep } from '@/services/apis/guides';

export interface Product {
  id: string;
  name: string;
  tagline: string;
  description: string;
  category: string;
  status: 'operational' | 'beta' | 'maintenance';
  icon: string;
  features: string[];
  users: string[];
  metrics: {
    [key: string]: string;
  };
  url?: string;
  slackChannels?: string[];
  contactPerson?: {
    name: string;
    email: string;
    role: string;
  };
}

export interface TutorialStep {
  id: string;
  title: string;
  content: string;
  type: 'text' | 'video' | 'code' | 'quiz' | 'pdf';
  order: number;
  videoUrl?: string;
  pdfUrl?: string;
  pdfFile?: File | null;
  audioUrl?: string;
  audioEnabled?: boolean;
  questions?: QuizQuestion[];
}

export interface QuizQuestion {
  id: string;
  question: string;
  title: string;
  options: string[];
  correctAnswer: number;
  explanation: string;
}

export interface TutorialResource {
  id: string;
  title: string;
  url: string;
  type: 'documentation' | 'external';
  description?: string;
}

export interface Tutorial {
  id: string;
  title: string;
  description: string;
  difficulty: 'beginner' | 'intermediate' | 'advanced';
  estimatedTime: string;
  category: string;
  product?: string | null;
  language?: 'en' | 'es';
  steps: TutorialStep[];
  resources?: TutorialResource[];
  authorId: string;
  isPublished: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface User {
  id: string;
  name: string;
  email: string;
  role: string;
}

export enum JobStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  SUCCESSFUL = 'SUCCESSFUL',
  PARTIAL_SUCCESS = 'PARTIAL_SUCCESS',
  FAILED = 'FAILED',
  MANUALLY_RESOLVED = 'MANUALLY_RESOLVED',
}

export enum ViewModeType {
  SLIDE = 'slide',
  SCROLL = 'scroll',
}

export interface GuideProgress {
  id: string;
  guideId: string;
  currentStepId: string | null;
  completedStepIds: string[];
  quizScores: { [stepId: string]: number };
  isCompleted: boolean;
  completedAt: string | null;
  startTime: string | null;
  language: string;
  createdAt: string;
  updatedAt: string;
}

export interface TransformedGuideData {
  id: string;
  title: string;
  description?: string;
  difficulty: string;
  estimatedTime?: number;
  steps: GuideStep[];
  translations: Array<{
    id: string;
    language: string;
    title: string;
    description?: string;
  }>;
}
